import { Address } from './adress';
import { Telecom } from './telecom';

export interface HealthcareserviceLocation {
  location_id?: string;
  name?: string;
  organization_id?: string;
  organization_name?: string;
  address?: {
    street?: string;
    number?: string;
    district?: string;
    city?: string;
    state?: string;
    line?: string[];
  };
}

export interface Healthcareservice {
  healthcareservice_id: string;
  name: string;
  tuss_code?: string;
  specialty_code?: string;
  type: string;
  status: boolean;
  description: string;
  extraDetails?: string;
  comments?: string;
  specialty?: string;
  organization: {
    organization_id: string;
    address?: Address;
    telecom?: Telecom;
    photo?: string;
    name: string;
  };
  price_low: string;
  price_high: string;
  appointmentRequired: boolean;
  active: boolean;
  averageDuration?: string;
  serviceType?: string;
  serviceDealer?: string;
  byOrderStartHour?: string;
  location?: HealthcareserviceLocation;
}

export interface HealthCareServiceAPIResponse {
  healthcareservice_id: string;
  name: string;
  tuss_code?: string;
  specialty_code?: string;
  description: string;
  extraDetails: string;
  comments?: string;
  status: boolean;
  providedBy: {
    reference: string;
    code: string;
    display: string;
  };
  category?: {
    coding: {
      system: string;
      code: string;
      display: string;
    }[];
  }[];
  type: {
    coding: {
      system: string;
      code: string;
      display: string;
    }[];
  }[];
  specialty: {
    coding: {
      system: string;
      code: string;
      display: string;
    }[];
  }[];
  valueRange: {
    low: {
      value: string | number;
      currency: string;
    };
    high: {
      value: string | number;
      currency: string;
    };
  };
  appointmentRequired: boolean;
  telecom?: {
    system: string;
    value: string;
    use: string;
  }[];
  availabilityExceptions?: string;
  active: boolean;
  averageDuration?: string;
  serviceType?: string;
  serviceDealer?: string;
  location?: HealthcareserviceLocation;
}

export interface HealthcareserviceSpecialists {
  name: string;
  healthcareservice_name?: string;
  healthcareservice_id: string;
  practitioner_name: string;
  practitioner_id: string;
  organization_name: string;
  organization_id: string;
  address: Address;
  telecom: Telecom;
}
